import { frontendURL } from '../../../helper/URLHelper';

import SettingsWrapper from '../settings/SettingsWrapper.vue';
import UsuariosIndex from './UsuariosIndex.vue';
import NovoUsuarioIndex from './NovoUsuarioIndex.vue';
import EquipesIndex from './EquipesIndex.vue';
import ModelosMensagensIndex from './ModelosMensagensIndex.vue';
import IntegracoesIndex from './IntegracoesIndex.vue';
import {
  hasIntegracoesPageData,
  prefetchIntegracoesPageData,
} from './integracoesPageData';
import PerfilIndex from './PerfilIndex.vue';
import SocialChannelsIndex from '../settings/socialChannels/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/configuracoes'),
      alias: [frontendURL('accounts/:accountId/configuracao')],
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'configuracoes_perfil',
            params: to.params,
          }),
        },
        {
          path: 'usuarios',
          name: 'configuracoes_usuarios',
          component: UsuariosIndex,
          meta: {
            permissions: ['administrator', 'settings_manage'],
            pagePermission: 'page_settings_agents',
          },
        },
        {
          path: 'novo-usuario',
          name: 'configuracoes_novo_usuario',
          component: NovoUsuarioIndex,
          meta: {
            permissions: ['administrator', 'settings_manage'],
            pagePermission: 'page_settings_agents',
          },
        },
        {
          path: 'equipes',
          name: 'configuracoes_equipes',
          component: EquipesIndex,
          meta: {
            permissions: ['administrator', 'settings_manage'],
            pagePermission: 'page_settings_teams',
          },
        },
        {
          path: 'ai-rodizios',
          name: 'configuracoes_ai_rodizios_legacy',
          redirect: to => ({
            name: 'configuracoes_equipes',
            params: to.params,
          }),
          meta: {
            permissions: ['administrator', 'settings_manage'],
            pagePermission: 'page_settings_teams',
          },
        },
        {
          path: 'modelos-mensagens',
          name: 'configuracoes_modelos_mensagens',
          component: ModelosMensagensIndex,
          meta: {
            permissions: ['administrator', 'settings_manage'],
            pagePermission: [
              'page_canned_responses',
              'page_settings_canned_responses',
            ],
          },
        },
        {
          path: 'integracoes',
          name: 'configuracoes_integracoes',
          component: IntegracoesIndex,
          // Carrega antes de a tela aparecer, como em agent.routes.js: sem
          // isso a pagina monta vazia e so entao dispara as chamadas,
          // mostrando "Carregando conexoes...". `finally`: uma falha de rede
          // nao pode travar a navegacao.
          beforeEnter: (to, from, next) => {
            if (hasIntegracoesPageData(to.params.accountId)) {
              next();
              return;
            }
            prefetchIntegracoesPageData(to.params.accountId).finally(() =>
              next()
            );
          },
          meta: {
            permissions: ['administrator', 'agent', 'integration_manage'],
            pagePermission: 'page_integrations',
          },
        },
        {
          path: 'canais-sociais',
          name: 'social_channels_settings',
          component: SocialChannelsIndex,
          meta: {
            permissions: ['administrator', 'agent', 'integration_manage'],
            pagePermission: 'page_integrations',
          },
        },
        {
          path: 'perfil',
          name: 'configuracoes_perfil',
          component: PerfilIndex,
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
        },
      ],
    },
  ],
};
